import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'

// 修改成员信息
export function webSaveClusterMember(param,callback){
	request({
			method: 'post',
			url: 'ClusterMember/save',
			data: param
	}).then((response)=>{
		if(response.data.code == 1){
			callback(true)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}

// 根据群id，获取群成员列表
export function webGetMemberByClusterId(cluster_id,callback){
	request({
			method: 'post',
			url: 'ClusterMember/getMemberByClusterId',
			data: {
				cluster_id:cluster_id
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}